module.exports = __webpack_public_path__ + "static/Afresh Technologies-7aa6753b0af139119414a335f0eeb0f3.jpg";